import { AssistantsService } from "@/generated";
import { useSpotUser } from "@/utils/spotUser";
import { DATA_KEYS } from "@/utils/useRemoteData";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SpotToast } from "../SpotToast";
import { NoxusIconPicker } from "../Flows/NoxusIconPicker";
import { SIZE_MAP } from "../UI/NoxusIcon";

export const AssistantIconPicker = ({
  assistantId,
  icon = "workflow",
  size = "md",
  isPublic = false,
  disabled = false,
}: {
  assistantId: string;
  icon?: string;
  size?: keyof typeof SIZE_MAP;
  isPublic?: boolean;
  disabled?: boolean;
}) => {
  const queryClient = useQueryClient();
  const { spotGroup } = useSpotUser();

  const updateAssistantMutation = useMutation({
    mutationFn: AssistantsService.updateAssistant,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DATA_KEYS.ASSISTANT_ID],
      });
      queryClient.invalidateQueries({
        queryKey: [DATA_KEYS.ASSISTANTS],
      });
      queryClient.invalidateQueries({
        queryKey: [DATA_KEYS.WORKSHOP_RECENT],
      });
    },
    onError: () => {
      SpotToast.error("Error updating agent");
    },
  });

  const handleIconClick = (newIcon: string) => {
    // in case we want to use the picker standalone
    updateAssistantMutation.mutate({
      body: { image_url: newIcon || "coworker" },
      path: {
        group_id: spotGroup.id,
        assistant_id: assistantId,
      },
    });
  };

  return (
    <NoxusIconPicker
      icon={icon}
      handleClick={handleIconClick}
      size={size}
      side="right"
      isPublic={isPublic}
      disabled={disabled}
    />
  );
};
